// The react-date-range Calendar paints itself from an inline theme whose defaults are fixed hex
// colors, white behind the days above all, so the app's theme never reached it. A null leaves a
// value to the stylesheet; a CSS variable follows the theme.
const CALENDAR_THEME = {
  Calendar: {
    background: 'var(--color-white)',
    color: null,
    width: 250,
  },
  MonthAndYear: {
    color: null,
    fontSize: null,
  },
  MonthButton: {
    background: null,
  },
  MonthArrow: {
    border: null,
  },
  MonthArrowPrev: {
    borderRightColor: null,
  },
  MonthArrowNext: {
    borderLeftColor: null,
  },
  Weekday: {
    color: null,
    fontWeight: null,
  },
  DayHover: {
    background: 'var(--color-gray-xlight)',
  },
  DayActive: {
    background: 'var(--color-gray-xlight)',
    color: null,
  },
  DayPassive: {
    color: null,
  },
  DaySelected: {
    background: null,
    color: null,
  },
  DayInRange: {
    background: null,
    color: null,
  },
};

export default CALENDAR_THEME;
